import {
  singleColumnStyles,
  singleColumnTabletStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  typoHeader,
  sectionWrapperStyles,
  horizontalWrapperStyles,
  typoHeaderMobile,
  typoParagraph,
  typoAgendaSmall,
} from 'components/Templates/styles/Red/commonObjectsStyles';

import details_arrow from 'components/Templates/globalAssets/icons/details_arrow.svg?url';
import arrowForward from 'components/Templates/globalAssets/icons/icons_arrow_red_forward.svg?url';
import arrowBackward from 'components/Templates/globalAssets/icons/icons_arrow_red_backward.svg?url';
import SpeakerStyling from './speakerStyling';


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...horizontalWrapperStyles,
      'width': '100%',
      'background-color': '#ffffff',
      'padding-top': '10rem',
      'padding-bottom': '10rem',
      'display': 'flex',
      'flex-direction': 'column',
    },
    '37_5': {
      'padding-left': '0',
      'padding-right': '0',
    }
  },
  sectionTitle: {
    '0': {
      ...singleColumnStyles,
      ...typoHeader,
      'margin-bottom': '2rem',
      'color': '{primaryColor}',
      'max-width': '160rem',
      'width': '75%',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'margin-top': '0',
      'margin-bottom': '6rem',
    },
    '76_8': {
      ...singleColumnTabletStyles,
      ...typoHeaderMobile,
      'margin-bottom': '2rem',
      'color': '{primaryColor}',
      'width': '90%',
    },
    '37_5': {
      'margin-left': '2rem',
    }
  },
  mainInnerWrapper: {
    '0': {
      ...sectionWrapperStyles,
      'width': '75%',
      'max-width': '160rem',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'padding-top': 0,
      'padding-bottom': 0,
    },
    '76_8': {
      'width': '95%',
    },
    '37_5': {
      'width': '99%',
    }
  },
  topOptionsWrapper: {
    '0': {
      'display': 'flex',
      'align-items': 'center',
      'border-bottom-width': '1px',
      'border-bottom-style': 'solid',
      'border-bottom-color': '{dividerColor}',
      'z-index': '12',
      'top': '10rem',
      'padding-top': '3rem',
      'margin-bottom': '2rem',
      'position': 'sticky',
      'background-color': '#fff'
    },
    '76_8': {
      'padding-top': '0',
    },
    '37_5': {
      'left': '0',
      'width': '100%',
      'overflow': 'visible'
    }
  }, 
  presentationBreak: {
    '0': {
      'border-bottom-width': '1px',
      'border-bottom-style': 'solid',
      'border-bottom-color': '{dividerColor}',
      'display': 'inline-block',
      'width': '100%',
      'margin-bottom': '-2px'
    }
  },

  presentationContainer: {
    '0': {
      'border-bottom-width': '1px',
      'border-bottom-style': 'solid',
      'border-bottom-color': '{dividerColor}',
      'display': 'inline-block',
      'width': '100%',
      'margin-bottom': '-2px'
    }
  },

  presentationTimeWrapper: {
    '0': {
      'float': 'left',
      'width': '6rem',
      'padding-left': '1rem'
    },
  },

  presentationTimeStart: {
    '0': {
      'margin-top': '1rem'
    },
  },
  presentationTrackTitle: {
    '0': {
      'margin-top': '1rem',
      'margin-bottom': '1rem'
    },
  },
  presentationContentWrapper: {
    '0': {
      'position': 'relative',
      'display': 'inline-block',
      'border-left-width': '1px',
      'border-left-style': 'solid',
      'border-left-color': '{dividerColor}',
      'height': '100%',
      'padding-left': '2rem',
      'padding-top': '2rem',
      'padding-bottom': '3rem',
      'width': 'calc(100% - 6rem)',
      'float': 'left',
      'cursor': 'pointer',
    },
  },
  presentationContentWrapper_hover: {
    '0': {
      'background-color': '#fafafa',
      'color': '{primaryColor}'
    }
  },
  presentationTitle: {
    '0': {
      'font-size': '3rem',
      'margin-bottom': '1rem',
    },
  },
  presentationDetailsWrapper: {
    '0': {
      'float': 'left'
    }
  },
  arrow: {
    '0': {
      'background-image': `url(${details_arrow})`,
      'width': '5rem',
      'height': '2rem',
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
      'margin-top': '1rem'
    }
  },
  presentationCompanyLogoWrapper: {
    '0': {
      'float': 'right',
      'position': 'relative',
      'display': 'inline-block',
      'float': 'right',
      'padding-right': '2rem'
    }
  },
  presentationCompanyLogo: {
    '0': {
      'width': '10rem',
      'height': '10rem',
      'margin-right': '1rem',
      'float': 'left',
      'background-color': 'rgba(255,255,255, 0.9)',
      'background-position': '50% 50%',
      'background-size': '70%',
      'background-repeat': 'no-repeat',
      'border-top-left-radius': '50%',
      'border-bottom-left-radius': '50%',
      'border-top-right-radius': '50%',
      'border-bottom-right-radius': '50%',
    }
  },
  dayTabsScroll: {
    '0': {
      ...horizontalWrapperStyles,
      'display': 'flex',
      'flex-wrap': 'nowrap',
      'color': '{secondaryTextColor}',
      'position': 'relative',
    },
    '37_5': {
      'width': '100%',
      'left': '0',
      'padding-left': '0'
    }
  },
  presentationSpeakerNameInline: {
    '0': {
      'color': '{textColor}',
      'margin-bottom': '0.1rem',
      'font-size': '1.5rem'
    }
  },

  dayTab: {
    '0': {
      'cursor': 'pointer',
      'font-size': '2.2rem',
      'padding-bottom': '3rem',
      'padding-right': '1rem',
      'padding-left': '1rem',
      'overflow': 'visible',
      'color': '{disabledTextColor}',
      'display': 'block'
    },
    '76_8': {
      'display': 'none'
    },
  },
  dayTitle: {
    '0': {
      'cursor': 'pointer',
      'font-size': '2.2rem',
      'padding-top': '3rem',
      'padding-bottom': '3rem',
      'padding-right': '1rem',
      'padding-left': '1rem',
      'overflow': 'visible',
      'display': 'block',
      'color': '{textColor}'
    },
  },
  dayDropdown: {
    '0': {
      'width': '100%',
      'margin-top': '0',
      'margin-bottom': '0',
      'display': 'none'
    },
    '76_8': {
      'display': 'block'
    },
  },
  link: {
    '0': {
      'margin-top': '2rem'
    }
  },
  fullScreenWrapper: {
    '0': {
      'position': 'fixed',
      'width': '100vw',
      'height': '100vh',
      'background-color': 'rgb(39 39 39 / 30%)',
      'left': '0',
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'overflow': 'auto',
      'max-width': '100%',
      'z-index': '1200',
      'top': '0'
    }
  },
  ...SpeakerStyling,


  linkClose: {
    '0': {
      'color': '{primaryColor}',
      'font-size': '1.2rem',
      'position': 'absolute',
      'cursor': 'pointer',
      'top': '1.5rem',
      'right': '1.5rem',
    }
  },
  linkClose_hover: {
    '0': {
      'text-decoration': 'underline'
    }
  },
  presentationSpeakerWrapperSingle: {
    '0': {
      'display': 'flex',
      'position': 'relative',
      'margin-top': '0.5rem',
      'flex-wrap': 'wrap',
      'width': '100%',
      'justify-content': 'space-between'
    }
  },
  presentationTitleSingle: {
    '0': {
      ...typoParagraph,
      'font-size': '2.4rem',
      'overflow': 'hidden',
      'margin-top': '1rem',
      'margin-bottom': '1rem',
      'font-weight': '700',
      'line-height': '1.4',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'display': '-webkit-box',
      '-webkit-box-orient': 'vertical',
    }
  },
  presentationTimeSingle: {
    '0': {
      ...typoAgendaSmall,
      'margin-right': '1rem',
      'display': 'inline'
    }
  },
  presentationTrackTitleSingle: {
    '0': {
      ...typoAgendaSmall,
      'margin-right': '1rem',
      'display': 'block'
    } 
  },
  presentationDescriptionSingle: {
    '0': {
      'font-size': '1.6rem',
      'margin-bottom': '7rem',
      'line-height': '1.6',
      'margin-top': '0.5rem',
      'max-width': '90%',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'line-height': '1.4',
      'margin-top': '2rem',
      'white-space': 'pre-line',
      'display': '-webkit-box',
      '-webkit-box-orient': 'vertical',
    }
  },
  prevPresentation: {
    '0': {
      'width': '4rem',
      'height': '4rem',
      'border-bottom-right-radius': '50%',
      'border-top-right-radius': '50%',
      'border-bottom-left-radius': '50%',
      'border-top-left-radius': '50%',
      'background-color': '{sectionBackgroundColor}',
      'position': 'absolute',
      'left': '-2rem',
      'top': '45%',
      'background-image': `url(${arrowBackward})`,
      'background-size': '50%',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'cursor':' pointer'
    },
    '76_8': {
      'top': 'initial',
      'bottom': '2rem',
      'left': 'initial',
      'right': '11rem',
      'width': '4rem',
      'height': '4rem',
    },
    '37_5': {
      'width': '5rem',
      'height': '5rem',
      'position': 'fixed',
      'right': 'initial'
    }
  },
  nextPresentation: {
    '0': {
      'width': '4rem',
      'height': '4rem',
      'border-bottom-right-radius': '50%',
      'border-top-right-radius': '50%',
      'border-bottom-left-radius': '50%',
      'border-top-left-radius': '50%',
      'background-color': '{sectionBackgroundColor}',
      'position': 'absolute',
      'right': '-2rem',
      'top': '45%',
      'background-image': `url(${arrowForward})`,
      'background-size': '50%',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'cursor':' pointer'
    },
    '76_8': {
      'top': 'initial',
      'bottom': '2rem',
      'right': '5rem',
      'width': '4rem',
      'height': '4rem',
    },
    '37_5': {
      'width': '5rem',
      'height': '5rem',
      'position': 'fixed',
      'right': 'initial',
      'left': '11rem'
    }
  },
  presentationTagsWrapper: {
    '0': {
      'display': 'flex',
      'flex-wrap': 'wrap',
      'margin-top': '1rem',
      'margin-bottom': '2rem',
      'row-gap': '1rem',
      'clear': 'both'
    }
  },
  filterTagItem: {
    '0': {
      'display': 'flex',
      'overflow': 'visible',
      'border-top-left-radius': '2rem',
      'border-bottom-left-radius': '2rem',
      'border-top-right-radius': '2rem',
      'border-bottom-right-radius': '2rem',
      'height': '3rem',
      'max-width': '21rem',
      'margin-top': '0.5rem',
      'margin-bottom': '0.5rem',
      'margin-right': '0.5rem',
      'margin-left': '0.5rem',
      'font-size': '1rem',
      'background-color': '{tagsColorActive}',
      'color': '{tagsColor}',
      'border-top-width': '1px',
      'border-bottom-width': '1px',
      'border-left-width': '1px',
      'border-right-width': '1px',
      'border-top-color': '{tagsColorActive}',
      'border-bottom-color': '{tagsColorActive}',
      'border-left-color': '{tagsColorActive}',
      'border-right-color': '{tagsColorActive}',
      'border-top-style': 'solid',
      'border-bottom-style': 'solid',
      'border-left-style': 'solid',
      'border-right-style': 'solid',
      'width': 'fit-content',
      'justify-content': 'center',
      'align-items': 'center',
      'padding-top': '1rem',
      'padding-bottom': '1rem',
      'padding-left': '1.5rem',
      'padding-right': '1.5rem',
      'text-transform': 'uppercase'
    },
    '37_5': {
      'overflow': 'hidden',
      'width': '100%',
    }
  },
  missingAgenda: {
    '0': {
      'width':'100%',
      'font-size': '2rem',
      'text-align': 'center',
      'padding-top': '3rem',
      'padding-bottom': '3rem',
    }
  }
}



thisStyle.prevPresentationDisabled = {
  '0': {
    ...thisStyle.prevPresentation['0'],
    'filter': 'grayscale(100%)'
  },
  '76_8': {
    ...thisStyle.prevPresentation['76_8'],
  },
  '37_5': {
    ...thisStyle.prevPresentation['37_5'],
  }
}

thisStyle.nextPresentationDisabled = {
  '0': {
    ...thisStyle.nextPresentation['0'],
    'filter': 'grayscale(100%)'
  },
  '76_8': {
    ...thisStyle.nextPresentation['76_8'],
  },
  '37_5': {
    ...thisStyle.nextPresentation['37_5'],
  }
}
thisStyle.presentationContainerSingle = {
  '0': {
    ...thisStyle.presentationContainer['0'],
    'padding-top': '3.5rem',
    'padding-bottom': '3.5rem',
    'padding-left': '3.5rem',
    'padding-right': '3.5rem',
    'opacity': '1',
    'min-width': '76rem',
    'min-height': '20rem',
    'height': 'unset',
    'max-width': '76rem',
    'background-color': '#FFFFFF',
    'margin-left': 'auto',
    'margin-right': 'auto',
    'margin-top': 'auto',
    'margin-bottom': 'auto',
    'top': '0',
    'padding-bottom': '10rem',
    'padding-top': '3rem',
  },
  '76_8': {
    'min-width': 'auto'
  },
  '37_5': {
    'padding-bottom': '20rem',
  },
}







thisStyle.dayTabActive = {
  '0': {
    ...thisStyle.dayTab['0'],
    'color': '{textColor}',
    'border-bottom-width': '2px',
    'border-bottom-style': 'solid',
    'border-bottom-color': '{primaryColor}',
  },
  '76_8': {
    ...thisStyle.dayTab['76_8']
  }
}

export default thisStyle;
